var _ellipse, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBilletera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 29,
    rx: 30.5,
    ry: 29,
    fill: "url(#paint0_linear_775_1304)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.06 31.325C38.43 31.94 38.07 32.825 38.16 33.77C38.295 35.39 39.78 36.575 41.4 36.575H44.25V38.36C44.25 41.465 41.715 44 38.61 44H21.39C18.285 44 15.75 41.465 15.75 38.36V28.265C15.75 25.16 18.285 22.625 21.39 22.625H38.61C41.715 22.625 44.25 25.16 44.25 28.265V30.425H41.22C40.38 30.425 39.615 30.755 39.06 31.325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.275 16.925V22.625H21.39C18.285 22.625 15.75 25.16 15.75 28.265V22.76C15.75 20.975 16.845 19.385 18.51 18.755L30.42 14.255C32.28 13.565 34.275 14.93 34.275 16.925Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.84 31.955V35.045C45.84 35.87 45.18 36.545 44.34 36.575H41.4C39.78 36.575 38.295 35.39 38.16 33.77C38.07 32.825 38.43 31.94 39.06 31.325C39.615 30.755 40.38 30.425 41.22 30.425H44.34C45.18 30.455 45.84 31.13 45.84 31.955Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30.125H22.5C21.885 30.125 21.375 29.615 21.375 29C21.375 28.385 21.885 27.875 22.5 27.875H33C33.615 27.875 34.125 28.385 34.125 29C34.125 29.615 33.615 30.125 33 30.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_775_1304",
    x1: 30.5,
    y1: 0,
    x2: 30.5,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE8036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E66226"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilletera);
export default __webpack_public_path__ + "static/media/Billetera.0ebf73d81fd6a5a834d61518103317a7.svg";
export { ForwardRef as ReactComponent };